import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-body" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "inner-box" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_divider = _resolveComponent("v-divider");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 실명: 1차 릴리즈에서 제외"),
        _createCommentVNode(" <v-row>\n      <v-col\n        cols=\"5\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular brg-color-grey-600\"\n        >\n          {{ '실명' }}\n        </v-card-title>\n      </v-col>\n      <v-col\n        cols=\"7\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular text-black\"\n        >\n          {{ detail.name }}\n        </v-card-title>\n      </v-col>\n    </v-row> "),
        _createCommentVNode(" 주민등록번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}social_number`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.socialNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 차량번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}car_number`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.carNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 면허번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}license_number`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.licenseNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_v_divider, { class: "horizontal-divider" }),
        _createCommentVNode(" 보유 바로머니 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}baromoney`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.detail.formattedBaromoney), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 고용보험 예치금 "),
        _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}employee_insurance_deposit`),
                "wide-title": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.formattedEmployeeInsuranceDepositBaromoney), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 산재보험 예치금 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}accident_insurance_deposit`),
                "wide-title": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.detail.formattedIndustrialAccidentInsuranceDepositBaromoney), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 허브설정 예치금 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}deposit_set_by_hub`),
                "wide-title": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.detail.formattedDepositBaromoney), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"])
        ]),
        _createCommentVNode(" <InputRow\n      :label=\"$t(`${lc}withdrawable_baromoney`)\"\n      wide-title\n      show-tooltip\n      :tooltip-text=\"$t(`${lc}withdrawable_description`)\"\n    >\n      <span class=\"body2-text text-black\">\n        {{ '백엔드 반영 대기중' }}\n      </span>\n    </InputRow> "),
        _createCommentVNode(" 보험상품명: 보험관련 모두 1차 릴리즈때 제외 "),
        _createCommentVNode(" <v-row>\n      <v-col\n        cols=\"5\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular brg-color-grey-600\"\n        >\n          {{ '보험상품명' }}\n        </v-card-title>\n      </v-col>\n      <v-col\n        cols=\"7\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular text-black\"\n        >\n          {{ }}\n        </v-card-title>\n      </v-col>\n    </v-row> "),
        _createCommentVNode(" 보험번호 "),
        _createCommentVNode(" <v-row>\n      <v-col\n        cols=\"5\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular brg-color-grey-600\"\n        >\n          {{ }}\n        </v-card-title>\n      </v-col>\n      <v-col\n        cols=\"7\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular text-black\"\n        >\n          {{ }}\n        </v-card-title>\n      </v-col>\n    </v-row> "),
        _createCommentVNode(" 보험료 "),
        _createCommentVNode(" <v-row>\n      <v-col\n        cols=\"5\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular brg-color-grey-600\"\n        >\n          {{ '보험료' }}\n        </v-card-title>\n      </v-col>\n      <v-col\n        cols=\"7\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular text-black\"\n        >\n          {{ }}\n        </v-card-title>\n      </v-col>\n    </v-row> "),
        _createCommentVNode(" 보험 가입일 "),
        _createCommentVNode(" <v-row>\n      <v-col\n        cols=\"5\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular brg-color-grey-600\"\n        >\n          {{ '보험 가입일' }}\n        </v-card-title>\n      </v-col>\n      <v-col\n        cols=\"7\"\n        class=\"py-2\"\n      >\n        <v-card-title\n          class=\"pa-0 body2-text font-weight-regular text-black\"\n        >\n          {{ }}\n        </v-card-title>\n      </v-col>\n    </v-row> ")
    ]));
}
